module.exports = __webpack_public_path__ + "media/site/images/contact-slider/contact_slideshow-06-7968da89fa0bdf7ff5fe740f366a2119.jpg";